/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '../../data/constants';

const slice = createSlice({
  name: 'scheduleAndDetails',
  initialState: {
    loadingDetailsStatus: RequestStatus.IN_PROGRESS,
    loadingSettingsStatus: RequestStatus.IN_PROGRESS,
    loadingIblStatus: RequestStatus.IN_PROGRESS,
    savingStatus: '',
    courseDetails: {},
    courseSettings: {},
    iblFormChoices: {},
  },
  reducers: {
    updateLoadingDetailsStatus: (state, { payload }) => {
      state.loadingDetailsStatus = payload.status;
    },
    updateLoadingSettingsStatus: (state, { payload }) => {
      state.loadingSettingsStatus = payload.status;
    },
    updateLoadingIblStatus: (state, { payload }) => {
      state.loadingIblStatus = payload.status;
    },
    updateSavingStatus: (state, { payload }) => {
      state.savingStatus = payload.status;
    },
    updateCourseDetailsSuccess: (state, { payload }) => {
      Object.assign(state.courseDetails, payload);
    },
    fetchCourseDetailsSuccess: (state, { payload }) => {
      Object.assign(state.courseDetails, payload);
    },
    fetchCourseSettingsSuccess: (state, { payload }) => {
      Object.assign(state.courseSettings, payload);
    },
    fetchIblCourseSettingsSuccess: (state, { payload }) => {
      // Merge IBL formData into courseDetails — same namespace, no separate key.
      Object.assign(state.courseDetails, payload.formData);
      state.iblFormChoices = payload.formChoices;
    },
    updateIblCourseSettingsSuccess: (state, { payload }) => {
      Object.assign(state.courseDetails, payload);
    },
  },
});

export const {
  updateSavingStatus,
  updateLoadingDetailsStatus,
  updateLoadingSettingsStatus,
  updateLoadingIblStatus,
  updateCourseDetailsSuccess,
  fetchCourseDetailsSuccess,
  fetchCourseSettingsSuccess,
  fetchIblCourseSettingsSuccess,
  updateIblCourseSettingsSuccess,
} = slice.actions;

export const {
  reducer,
} = slice;
